import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AnnouncementService } from 'src/app/announcement/shared/services/announcement.service';
import * as frontPageActions from './announcement-front-page-actions';
import { mergeMap, map, catchError, debounceTime, withLatestFrom, filter, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { BannerService } from 'src/app/banner/shared/services/banner.service';
import { selectAnnouncements, selectAnnouncementState } from './search-page/selectors';
import { Store } from '@ngrx/store';
import { BannerTargetEnum } from 'src/app/banner/shared/models/enums/banner-target-enum';

export {
}

@Injectable()
export class AnnouncementsEffects{
    loadFrontPageAnnouncements$ = createEffect(() =>
        this.actions$.pipe(
            ofType(frontPageActions.loadFrontPageAnnouncements),
            debounceTime(300),
            withLatestFrom(this.store.select(selectAnnouncementState)),
            mergeMap(([data, announcement]) => {
                const shouldLoad = !(data.payload.page === 1 && announcement.frontpage.announcements.length > 0);
                
                if (!shouldLoad) {
                    return of(frontPageActions.loadFrontPageAnnouncementsSkipped());
                }
                
                // Todo: data.payload.targetId
                return this.announcementService.getFrontPageModel(data.payload.page, BannerTargetEnum.Responsive).pipe(
                    map(announcements => frontPageActions.loadFrontPageAnnouncementsSuccess({ payload: announcements.data })),
                    catchError(error => of(frontPageActions.loadFrontPageAnnouncementsFail({ payload: { error } })))
                );
            })
        )
    );

    loadFavoriteAnnouncements$ = createEffect(() => this.actions$.pipe(
        ofType(frontPageActions.loadFavoriteAnnouncements),
        mergeMap(() => this.announcementService.getFavoriteAnnouncements()
        .pipe(
            map(response => frontPageActions.loadFavoriteAnnouncementsSuccess({payload: response.data})),
            catchError(error => of(frontPageActions.loadFavoriteAnnouncementsFail({payload: { error: error }})))
        )
       )
    ));

    loadMetadata$ = createEffect(() => this.actions$.pipe(
        ofType(frontPageActions.loadFrontPageMetaData),
        mergeMap(() => this.announcementService.getMetaData()
        .pipe(
            map(response => frontPageActions.loadFrontPageMetaDataSuccess({payload: response.data})),
            catchError(error => of(frontPageActions.loadFrontPageMetaDataFail({payload: { error: error }})))
        )
       )
    ));

    getMainPageBannerList$ = createEffect(() => this.actions$.pipe(
        ofType(frontPageActions.getFrontPageBannerList),
        mergeMap(action => this.bannerService.getBannerList(action.payload.targetId, action.payload.bannerHeadPositionId)
        .pipe(
            map(response => frontPageActions.getFrontPageBannerListSuccess({payload: response.data})),
            catchError(error => of(frontPageActions.getFrontPageBannerListFailed({payload: error.error})))
        ))
    ));

    constructor(private actions$: Actions, private announcementService: AnnouncementService, private bannerService: BannerService, private store: Store){}
}